import PropTypes from 'prop-types';

import IOSSwitch from '../../../../components/Switch';
import { GREY } from '../../../../constants/color';

const EstimationSwitch = ({ enabled, handleChange, title, subTitle }) => {
  return (
    <div className='flex w-full justify-between'>
      <div className='flex gap-1 flex-col'>
        <h3 className='font-semibold text-sm'>{title}</h3>
        <p className={`font-medium text-xs text-[${GREY}]`}>{subTitle}</p>
      </div>
      <div>
        <IOSSwitch checked={enabled} onChange={handleChange} />
      </div>
    </div>
  );
};

EstimationSwitch.propTypes = {
  title: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  subTitle: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default EstimationSwitch;
